import Returnable from "vuetify/lib/mixins/returnable";
import {
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VCardTitle,
	VMenu,
	VSpacer
} from "vuetify/lib";

export default {
	name: "KEditDialog",

	mixins: [ Returnable ],

	props: {
		persistent: Boolean,

		cancelText: {
			default: "Cancel",
			type: String
		},

		saveText: {
			default: "Save",
			type: String
		},

		title: {
			default: "Update Field",
			type: String
		}
	},

	data: () => ( {
		isActive: false
	} ),

	watch: {
		isActive( isActive ) {
			this.$nextTick( () => {
				if ( isActive && this.$refs.input ) {
					const input = this.$refs.input.querySelector( "input" );

					if ( input ) {

						// Give DOM time to paint - copied from Vuetify
						setTimeout( () => {
							input.select();
						}, 50 );
					}
				}
			} );
		}
	},

	methods: {
		keyDownHandler( e ) {
			if ( e.keyCode === 13 ) {
				this.saveAndEmit();
			}
		},

		saveAndEmit() {
			this.save( this.returnValue );
			this.$emit( "save", this.returnValue );
		}
	},

	render() {
		return <VMenu
			bottom
			closeOnClick={!this.persistent}
			closeOnContentClick={false}
			left
			offsetY
			vModel={this.isActive}
			scopedSlots={this.$scopedSlots}
		>
			<VCard>
				<VCardTitle class="text-subtitle-1 primary white--text">
					{this.title}
				</VCardTitle>

				<VCardText ref="input" onKeydown={this.keyDownHandler}>
					{this.$slots.input}
				</VCardText>

				<VCardActions>
					<VBtn
						onClick={() => this.isActive = false}
						text
					>{this.cancelText}</VBtn>

					<VSpacer></VSpacer>

					<VBtn
						color="link"
						onClick={this.saveAndEmit}
						text
					>{this.saveText}</VBtn>
				</VCardActions>
			</VCard>
		</VMenu>;
	}
};
